import ActiveUserContext from "../../utils/session/ActiveUserContext";
import PageFramework from "../../common/components/layout/PageFramework/PageFramework";

import { ReactElement, useContext } from "react";

import TabletopWorkspace from "./components/TabletopWorkspace";

export default function TabletopPage(): ReactElement {
    const activeUser = useContext(ActiveUserContext);

    return (
        <PageFramework>
            <TabletopWorkspace />
        </PageFramework>
    );
}
